/* eslint-disable no-console */
<template>

    <div class="main_unit">
        <pulse-loader class="w-100 text-center" :loading="isInitLoading"></pulse-loader>
        <div v-show="!isInitLoading">
            <div class="store_login_unit_manage_menu">企業管理者画面</div>
            <div class="wd976 tbl_ht_login_info tbl_bg_blue">
                    <form class="form_checkSetting_Tyori">
                    <div class="wd720">
                        <p class="checkSetting_text">調理名一覧</p><br>
                        <Message v-if="validationMessage" :validationMessage="alertMessage" /><br>
                        <Message v-if="validationMessage" :validationMessage="validationMessage" />
                    </div>

                    <div class="lavel_tyori right_comment">
                        <label for="diesplaySet_id" class="mgb_20">ボタン選択</label>
                    </div>
                    <div class="wd200 mgl_24" id="diesplaySet_id" @change="selectCookingId($event)" >
                        <select class="wd200"  v-model="selectButton">
                            <option value="null" disabled>ボタンを選択</option>
                            <option :value="cookingButton.cookingCheckButtonId" v-for="cookingButton in cookingCheckButton" :key="cookingButton.cookingCheckButtonId">
                                {{cookingButton.upperButtonName}} {{cookingButton.lowerButtonName}}</option>
                        </select>
                    </div>

                    <div class="lavel_store right_comment" style="vertical-align: middle">
                        <label for="releaseSelect">リリース日</label>
                    </div>
                    <div class="input_store left_comment selectFile mgl_10" id="releaseSelect">
                        <select v-if="selectButton === null" class="wd250" disabled></select>
                        <select v-else v-model="applyStartDate" class="wd250" @change="init">
                            <option v-for="releaseHistory in releaseHistories" :key="releaseHistory" :value="releaseHistory" :id="releaseHistory">
                                {{releaseHistory}}</option>
                        </select>
                        <label v-if="selectButton === null" class="selectFile__label">取消<input type="button" id="arrangement99" disabled><br></label>
                        <label v-else class="selectFile__label">取消<input type="button" id="arrangement15" @click="releaseDayDelete"><br></label>
                    </div>

                    <div class="lavel_store right_comment">
                        <img v-if="selectButton !== null" class="required" src="../assets/required.png" />
                        <label for="releaseInput">リリース日を入力</label>
                    </div>
                    <div class="input_store left_comment wd280 mgl_10" id="releaseInput">
                        <div v-if="selectButton === null">
                            <input class="wd250 height_text" name="buttonname" type="text" disabled />
                        </div>
                        <div v-else>
                            <v-date-picker ref="picker" v-model="date" mode="single" :masks="{ input: ['YYYY/MM/DD']}" :min-date="vDatePickerMinDay"></v-date-picker>
                        </div>
                    </div>
                    <div class="lavel_tyori right_comment">
                        <label for="alert_all_setting">アラート一括設定</label>
                        <input type="checkbox" name="checkbox02" id="alertAllSetting" v-model="isLump" :value="1" @change="chengIsLump">
                        <label class="checkbox02" for="alertAllSetting"></label>
                    </div>
                    <div class="input_store mgl_10 left_comment" id="alertAllSetting">
                        <input type="text" class="textbox_td_tyori text-left" readonly :disabled="isLump == 0" :value="lumpAlertSetting.format" @click.prevent.stop="clickLumpAlertSetting" style="border: 1px solid #949393;border-radius:5px;">
                    </div>

                    <div class="lavel_tyori right_comment">
                        <label for="diesplayAdd_id"></label>
                    </div>
                    <div class="admin_button_top_unit mgl_10" id="diesplayAdd_id">
                        <div class="checkSetting_buttan_unit ">
                            <div class="checkSetting_kanri_box ">
                                <ul class="ul_tbl_buttan"><li><a href="#" @click.prevent.stop="addColum">行追加</a></li></ul>
                            </div>
                        </div>
                    </div>

                    <div class="lavel_tyori right_comment">
                        <label for="diesplaySetList_id"></label>
                    </div>
                    <div  class="tbl_bg_blue mgt_15" name="pageSetting" id="diesplaySetList_id" >
                        <table class="tyori_checkSetting_tbl_unit wd750 tyori_setting_height tyori_setting_table mgl_24">
                            <thead>
                                <tr>
                                    <th class="wd70 cooking_setting_sticky_top cooking_setting_sticky_left z_3" rowspan="3" style="text-align: center">表示順</th>
                                    <th class="wd240 cooking_setting_sticky_top cooking_setting_sticky_left_70 z_3" rowspan="3" style="text-align: center">調理名</th>
                                    <th v-if="rowspan <= 2" class="wd120 cooking_setting_sticky_top" colspan="2" style="text-align: center">加熱後温度</th>
                                    <th v-if="rowspan > 2" class="wd120 cooking_setting_sticky_top" rowspan="2" colspan="2" style="text-align: center">加熱後温度</th>
                                    <th v-if="cookingCheckButtonNo == 5 && rowspan <= 2" class="wd120 cooking_setting_sticky_top" colspan="2" style="text-align: center">再加熱後温度</th>
                                    <th v-if="cookingCheckButtonNo == 5 && rowspan > 2" class="wd120 cooking_setting_sticky_top" rowspan="2" colspan="2" style="text-align: center">再加熱後温度</th>
                                    <th class="wd240 cooking_setting_sticky_top" rowspan="3" style="text-align: center">グループ名</th>
                                    <th class="wd350 cooking_setting_sticky_top" :colspan = colGroupAllCount style="text-align: center">入力制御</th>
                                    <th class="wd70 cooking_setting_sticky_top" rowspan="3" style="text-align: center">アラート通知</th>
                                    <th class="wd100 cooking_setting_sticky_top" rowspan="3" style="text-align: center">アラート通知時間</th>
                                    <th class="wd100 cooking_setting_sticky_top" rowspan="3" style="text-align: center">移動</th>
                                    <th class="wd100 cooking_setting_sticky_top" rowspan="3" style="text-align: center">削除</th>
                                </tr>
                                <tr v-if="rowspan > 2" class="text_white_space">
                                    <th v-for="groupSetting in colGroupSetting" :key="groupSetting.colGroupName" class="wd70 test_padding cooking_setting_sticky_top_50" :colspan="groupSetting.colGroupCount" style="text-align: center">
                                        {{groupSetting.colGroupName}}</th>
                                </tr>
                                <tr>
                                    <th class="text_white_space cooking_setting_sticky_top_50" :class="{'cooking_setting_sticky_top_100':rowspan > 2}" style="text-align: center">下限</th>
                                    <th class="text_white_space cooking_setting_sticky_top_50" :class="{'cooking_setting_sticky_top_100':rowspan > 2}" style="text-align: center">上限</th>
                                    <th v-if="cookingCheckButtonNo == 5" class="text_white_space cooking_setting_sticky_top_50" :class="{'cooking_setting_sticky_top_100':rowspan > 2}" style="text-align: center">下限</th>
                                    <th v-if="cookingCheckButtonNo == 5" class="text_white_space cooking_setting_sticky_top_50" :class="{'cooking_setting_sticky_top_100':rowspan > 2}" style="text-align: center">上限</th>
                                    <th class="wd70 text_white_space cooking_setting_sticky_top_50" :class="{'cooking_setting_sticky_top_100':rowspan > 2}"  v-for="headerItemName in headerItemNameList" :key="headerItemName.cookingCheckHeaderId" style="text-align: center">
                                        {{headerItemName.lowerButtonName}}</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="(cookingNameListData,index) in cookingCheckButtonData.cookingNameList" :key="index">
                                    <td class="cooking_setting_sticky_left">{{cookingNameListData.cookingNameNo}}</td>
                                    <td class="cooking_setting_sticky_left_70"><input type="text" class="textbox_td_tyori text-left" maxlength="20" v-model="cookingNameListData.cookingName"></td>
                                    <td><input type="text" class="wd60" v-model="cookingNameListData.heatedLowerTemperature" maxlength="5"></td>
                                    <td><input type="text" class="wd60" v-model="cookingNameListData.heatedUpperTemperature" maxlength="5"></td>
                                    <td v-if="cookingCheckButtonNo == 5"><input type="text" class="wd60" v-model="cookingNameListData.reHeatedLowerTemperature" maxlength="5"></td>
                                    <td v-if="cookingCheckButtonNo == 5"><input type="text" class="wd60" v-model="cookingNameListData.reHeatedUpperTemperature" maxlength="5"></td>
                                    <td>
                                      <input class="wd240" list="groupNameList" v-model="cookingNameListData.groupName" @blur="changeGroupName">
                                      <datalist class="wd240" id="groupNameList">
                                        <option v-for="groupName in groupNameList" :key="groupName" :value="groupName">
                                          {{groupName}}
                                        </option>
                                      </datalist>
                                    </td>
                                    <td v-for="(inputListData,indexCount) in cookingNameListData.inputList" :key="inputListData.cookingCheckHeaderId">

                                          <a v-if="inputListData.inputFlg == 0" href="#" role="button" @click.prevent.stop="clickChech(index,indexCount,inputListData.cookingCheckHeaderId)">
                                              <p class="icn_white_td"><i class="far fa-circle"></i></p></a>
                                          <a v-if="inputListData.inputFlg == 1" href="#" role="button" @click.prevent.stop="clickChech(index,indexCount,inputListData.cookingCheckHeaderId)">
                                              <p class="icn_blue_td"><i class="far fa-circle"></i></p></a>
                                          <a v-if="inputListData.inputFlg == 2" href="#" role="button" @click.prevent.stop="clickChech(index,indexCount,inputListData.cookingCheckHeaderId)">
                                              <p class="icn_yellow_td"><i class="fas fa-play" style="transform: rotate(-90deg)"></i></p></a>

                                    </td>
                                    <td class="checkSetting_text_align">
                                        <select v-model="cookingNameListData.alertSetting.isSet" class="select_height">
                                          <option :value="1" >有</option>
                                          <option :value="0" >無</option>
                                        </select>
                                    </td>
                                    <td class="wd70" style="text-align: center">
                                      <input type="text" class="textbox_td_tyori text-left" readonly :disabled="isLump == 1" :value="cookingNameListData.alertSetting.format" @click.prevent.stop="clickAlertSetting(index)" style="border: 1px solid #949393;border-radius:5px;">
                                    </td>
                                    <td v-if="index == 0" class="wd100" style="text-align: center" >
                                        <input type="button" value="▼" @click="lowArrangement(index)">
                                    </td>
                                    <td v-else-if="index == cookingCheckButtonData.cookingNameList.length-1" class="wd100" style="text-align: center" >
                                        <input type="button" value="▲" @click="upArrangement(index)"><br>
                                    </td>

                                    <td v-else class="wd100" style="text-align: center">
                                        <input type="button" value="▲" @click="upArrangement(index)"><br>
                                        <input type="button" value="▼" @click="lowArrangement(index)">
                                    </td>
                                    <td>
                                        <div class="checkSetting_kanri_box ">
                                            <ul class="ul_tbl_buttan"><li><a href="#" @click.prevent.stop="delecSelect(index)">削除</a></li></ul>
                                        </div>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </form><br>
            </div>
            <div>
                <div class="btn_submit" style="text-align: center">
                    <ul class="set_ul_tbl_buttan" style="display: inline-block">
                        <li>
                            <router-link class="checkSetting_buttan_unit" :to="{ name: 'managemenu'} ">キャンセル</router-link>
                        </li>
                    </ul>
                    <ul class="set_ul_tbl_buttan" style="display: inline-block">
                        <li><a class="checkSetting_buttan_unit " href="#" @click.prevent.stop="releaseDayUpAdd">更新</a></li>
                    </ul>
                    <ul class="set_ul_tbl_buttan" style="display: inline-block">
                        <li><a class="checkSetting_buttan_unit btn_preview_color" href="#" @click.prevent.stop="openPreview()">プレビュー</a></li>
                    </ul>
                </div>
            </div>
        </div>
        <div class="overlay_loder" v-show="isLoading">
            <pulse-loader class="w-100 text-center" :loading="isLoading"></pulse-loader>
        </div>
        <div class="overlay" v-show="showContent2">
            <div>
                <div class="modal_box wd570">
                    <div class="modal_header_unit">
                        <div class="modal_header_box">
                            <p v-if="showContentKbn == 1" class="modal_header_tit">調理名登録 新規登録</p>
                            <p v-if="showContentKbn == 2" class="modal_header_tit">調理名登録 更新確認</p>
                            <p v-if="showContentKbn == 3" class="modal_header_tit">調理名登録 取消確認</p>
                        </div>
                    </div>
                    <div class="modal_content_tex">
                        <p v-if="showContentKbn == 1 && date !== null">リリース日{{selectDateFormat(this.date)}}の設定を新規登録します。<br>よろしいですか？
                            <br><br>現時点での表示設定に戻ります。<br>登録/更新した情報を確認する場合には、上部「リリース日」にて日付を選択してください。</p>
                        <p v-if="showContentKbn == 2 && date !== null && updateKbn ==1">リリース日{{selectDateFormat(this.date)}}の設定を更新します。<br>よろしいですか？
                            <br><br>現時点での表示設定に戻ります。<br>登録/更新した情報を確認する場合には、上部「リリース日」にて日付を選択してください。</p>
                        <p v-if="showContentKbn == 3 && applyStartDate !== null">リリース日{{applyStartDate}}の設定を取消します。<br>よろしいですか？</p>
                    </div>
                    <div class="btn_submit_box">
                        <div class="btn_submit2">
                            <a href="#" @click.prevent.stop="closeModelDelete">キャンセル</a>
                        </div>
                        <div class="btn_submit">
                            <a v-if="showContentKbn == 1" href="#" @click.prevent.stop="sendSenser">OK</a>
                            <a v-if="showContentKbn == 2" href="#" @click.prevent.stop="sendSenser">OK</a>
                            <a v-if="showContentKbn == 3" href="#" @click.prevent.stop="delModel">OK</a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="overlay" v-show="showContent3">
            <div>
                <div class="modal_box wd570">
                    <div class="modal_header_unit">
                        <div class="modal_header_box">
                            <p v-if="showContentKbn == 1" class="modal_header_tit">調理名登録 新規登録</p>
                            <p v-if="showContentKbn == 2" class="modal_header_tit">調理名登録 更新確認</p>
                            <p v-if="showContentKbn == 3" class="modal_header_tit">調理名登録 削除確認</p>
                        </div>
                    </div>
                    <div class="modal_content_tex">
                        <p v-if="showContentKbn == 1">登録しました。</p>
                        <p v-if="showContentKbn == 2">更新しました。</p>
                        <p v-if="showContentKbn == 3">取消しました。</p>
                    </div>

                    <div class="btn_submit_box">
                        <div class="btn_submit">
                            <a href="#" @click.prevent.stop="closeModelComp">OK</a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="overlay" v-show="showContent4">
            <div>
                <div class="modal_box wd570">
                    <div class="modal_header_unit">
                        <div class="modal_header_box">
                            <p class="modal_header_tit">アラート通知設定</p>
                        </div>
                    </div>
                    <div class="modal_content_tex">
                      <div class="modal_alert_setting_box">
                        <div class="model_alert_setting_item">
                          <div class="wd45 align-items-center"></div>
                          <label class="mgl_10 mgr_10">設定:</label>
                          <input type="text" class="wd200 textbox_td_tyori text-left" readonly v-model="alertSetting.format" style="border: 1px solid #949393;border-radius:5px;">
                        </div>
                        <div class="model_alert_setting_item">
                          <div class="wd45 align-items-center"></div>
                          <label class="mgl_10 mgr_10" >時間:</label>
                          <vue-timepicker @change="changeFormat" input-width="200px"  minute-interval="60" v-model="alertSetting.time" :hide-clear-button="true"></vue-timepicker>
                        </div>
                        <div class="model_alert_setting_item">
                          <input class="wd45" type="radio" name="checkbox02" id="repeat0" v-model="alertSetting.repeat_type" :value='0' @change="changeFormat">
                          <label class="mgl_10 mgr_10 form-check-label" for="repeat_type">毎日:</label>
                          <div class="wd200" >{{alertSetting.time}}</div>
                        </div>
                        <div class="model_alert_setting_item">
                          <input class="wd45" type="radio" name="checkbox02" id="repeat1" v-model="alertSetting.repeat_type" :value='1' @change="changeFormat">
                          <label class="mgl_10 mgr_10">曜日:</label>
                          <select class="wd200"  v-model="alertSetting.weekday" @change="changeFormat">
                            <option v-for="d in weekdays" :key="d.value" :value="d.value">{{ d.text }}</option>
                          </select>
                        </div>
                        <div class="model_alert_setting_item">
                          <input class="wd45" type="radio" name="checkbox02" id="repeat2" v-model="alertSetting.repeat_type" :value='2' @change="changeFormat">
                          <label class="mgl_10 mgr_10">毎月:</label>
                          <select class="wd90"  v-model="alertSetting.monthday" @change="changeFormat">
                            <option v-for="d in monthdays" :key="d.value" :value="d.value">{{ d.text }}</option>
                          </select>
                          <select class="wd90 mgl_10"  v-model="alertSetting.monthday_second" @change="changeFormat">
                            <option v-for="d in monthdays" :key="d.value" :value="d.value">{{ d.text }}</option>
                          </select>
                          <button class="mgl_10" style="height: 20px;display: flex;align-items: center;border: 1px solid #c4bfbf;" @click="clearMonthday">x</button>
                        </div>

                      </div>
                    </div>
                  <div class="btn_submit_box">
                    <div class="btn_submit2">
                      <a href="#" @click.prevent.stop="closeAlertSettingModel">キャンセル</a>
                    </div>
                    <div class="btn_submit">
                      <a href="#" @click.prevent.stop="setAlertSetting">OK</a>
                    </div>
                  </div>
                </div>
            </div>
        </div>
    </div>

</template>

<script>
    import PulseLoader from '@/app/components/PulseLoader.vue'
    import Message from '@/app/components/Message.vue'
    import VueTimepicker from 'vue2-timepicker'
    import 'vue2-timepicker/dist/VueTimepicker.css'
export default {
    name: 'TyoriSetting',
    components: {
        PulseLoader,
        Message,
        VueTimepicker,
    },
    data: function () {
        return {
            vDatePickerMinDay:null,
            updateKbn:0,
            selectButton:null,
            showContentKbn:null,
            selectIndex:null,
            showContent4:false,
            showContent3:false,
            showContent2:false,
            applyStartDate:null,
            releaseHistories:[],
            date:null,
            errr:null,
            isLoading:false,
            isInitLoading:true,
            validationMessage:'',
            alertMessage:'入力エラーがあります。',
            showContent:false,
            rowspan:0,
            colGroupSetting:[{colGroupCount:null,colGroupName:''}],
            colGroupAllCount:0,
            selectButtonId:null,
            cookingCheckButtonId:null,
            tyoriDataList:[
                {no:null,cookingName:'',inputList:[{cookingCheckHeaderId:null,inputFlg:null}]}
            ],
            headerItemNameList:[{lowerButtonName:'',cookingCheckHeaderId:null}],
            // 重要管理項目チェックボタン一覧取得
            cookingCheckButton: null,
            cookingCheckButtonNo:0,
            cookingCheckButtonData: {
                cookingCheckButtonId: "",
                cookingNameList: null,
                headerItemList: null,
                applyStartDate:null,
                releaseHistories:null
            },
            selectGroupName:"",
            groupNameList:[],
            alertSetting: {
              format:'毎日 00:00',
              isSet: 0,
              time:'00:00',
              repeat_type: 0,
              weekday: 0,
              monthday: 1,
              monthday_second: null,
            },
            lumpAlertSetting: {
              format:'毎日 00:00',
              isSet: 0,
              time:'00:00',
              repeat_type: 0,
              weekday: 0,
              monthday: 1,
              monthday_second: null,
            },
            weekdays: [
              { text: '月', value: 1 },
              { text: '火', value: 2 },
              { text: '水', value: 3 },
              { text: '木', value: 4 },
              { text: '金', value: 5 },
              { text: '土', value: 6 },
              { text: '日', value: 0 },
            ],
            monthdays: [
              { text: '1日', value: 1 }, { text: '2日', value: 2 }, { text: '3日', value: 3 }, { text: '4日', value: 4 },
              { text: '5日', value: 5 }, { text: '6日', value: 6 }, { text: '7日', value: 7 }, { text: '8日', value: 8 },
              { text: '9日', value: 9 }, { text: '10日', value: 10 }, { text: '11日', value: 11 }, { text: '12日', value: 12 },
              { text: '12日', value: 13 }, { text: '14日', value: 14 }, { text: '15日', value: 15 }, { text: '16日', value: 16 },
              { text: '17日', value: 17 }, { text: '18日', value: 18 }, { text: '19日', value: 19 }, { text: '20日', value: 20 },
              { text: '21日', value: 21 }, { text: '22日', value: 22 }, { text: '23日', value: 23 }, { text: '24日', value: 24 },
              { text: '25日', value: 25 }, { text: '26日', value: 26 },{ text: '27日', value: 27 }, { text: '28日', value: 28 },
              { text: '29日', value: 29 }, { text: '30日', value: 30 },{ text: '31日', value: 31 }, { text: '月末', value: 0 },
            ],
            isLump:0,
        }
    },
    computed:{
        brandPath: function () {
            return this.$store.getters['brand/path']
        },
    },
    created: function(){
        this.calc();
    },
    methods:{
        async calc(){

            this.isInitLoading = true;

            //重要管理項目メニュー設定取得API
            var brandId = this.$store.getters['brand/id'];
            var datetime = this.dateFormat();
            var url = this.$apiEndpoint + 'manage/brand/' + brandId + '/cooking_check?datetime=' + datetime;

            await this.$axios
                .get(url)
                .then(response => (this.cookingCheckButton = response.data.cookingCheckButton))
                .catch((err)=> {
                    let error = {
                        button: {
                            path: {name: 'top', params:{brandPath: this.brandPath}}
                        }}
                    if (err.customError) {
                        error = Object.assign(error, err.customError)
                    }
                    this.$store.dispatch('error/setError', error).then(this.$router.push({name: 'error'}))
                }).finally(()=> this.isInitLoading = false);

        },
        openPreview() {
            this.isLoading = true;

            //エラー内容初期化
            this.clearError();

            // 種別の選択確認
            if(this.cookingCheckButtonId === null){
                this.validationMessage = 'ボタン名を選択してください。'
                this.isLoading = false;
                this.scrollTop();
                return null;
            }

            let cookingNameListArray = this.cookingCheckButtonData.cookingNameList;
            let cookingList = this.getRequestArray(cookingNameListArray);

            // バリデーションチェック
            if(!this.validationCheckForPreview(cookingNameListArray)){
                this.isLoading = false;
                this.scrollTop();
                return null;
            }

            cookingList = cookingList.map(x => {
                return {
                    cookingName: x.cooking_name,
                    cookingNameNo: x.no,
                    inputList: x.inputList.map(y => {
                        return {
                            cookingCheckHeaderId: y.cooking_check_header_id,
                            inputFlg: y.input_flg,
                        }
                    }),
                    groupName: x.groupName,
                    heatedUpperTemperature:x.heatedUpperTemperature,
                    heatedLowerTemperature:x.heatedLowerTemperature,
                    reHeatedUpperTemperature:x.reHeatedUpperTemperature,
                    reHeatedLowerTemperature:x.reHeatedLowerTemperature,
                }
            });

            let previewInfo = {
                upperButtonName: '',
                lowerButtonName: '',
                cookingList: cookingList
            };

            this.cookingCheckButton.some(obj => {
                if(obj.cookingCheckButtonId == this.cookingCheckButtonId){
                    previewInfo.upperButtonName = obj.upperButtonName;
                    previewInfo.lowerButtonName = obj.lowerButtonName;
                    return true;
                }
            });

            this.$store.dispatch('preview/doClear')
            this.$store.dispatch('preview/setPreviewInfo', previewInfo);

            //別タブ表示
            let routeData = this.$router.resolve({name: 'cookingCheckInputPreview', params: { subMenuId: Number(this.cookingCheckButtonId) }});
            window.open(routeData.href, '_blank');
            this.isLoading = false;
        },
        validationCheckForPreview(cookingNameListArray){

            //最小件数チェック
            if (cookingNameListArray.length == 0) {
                this.validationMessage = '調理名は1件以上登録を実施してください。'
                return false;
            }

            //最大件数チェック
            if (cookingNameListArray.length>200) {
                this.validationMessage = '調理名は200件まで登録可能です'
                return false;
            }

            //必須チェック
            for(var L = 0 ; L < cookingNameListArray.length ; L++) {
                if(!cookingNameListArray[L].cookingName){
                    this.validationMessage = "調理名を入力してください。";
                    return false;
                }
            }

            //重複チェック
            for(var h = 0 ; h < cookingNameListArray.length ; h++) {

                if ((h + 1) !== cookingNameListArray.length) {
                    var inpuotApiDataObj = cookingNameListArray[h];
                    for (var i = h+1; i < cookingNameListArray.length; i++) {
                        if (inpuotApiDataObj.cookingName == cookingNameListArray[i].cookingName) {
                            this.validationMessage = '調理名は既に登録されています'
                            return false;
                        }
                    }
                }
            }
            return true;
        },
        validationCheck(cookingNameListArray) {

            // 種別の選択確認
            if(this.cookingCheckButtonId === null){
                this.validationMessage = 'ボタン名を選択してください。'
                return false;
            }

            //最小件数チェック
            if (cookingNameListArray.length == 0) {
                this.validationMessage = '調理名は1件以上登録を実施してください。'
                return false;
            }

            //最大件数チェック
            if (cookingNameListArray.length>200) {
                this.validationMessage = '調理名は200件まで登録可能です'
                return false;
            }

            //必須チェック
            for(var L = 0 ; L < cookingNameListArray.length ; L++) {
                if(!cookingNameListArray[L].cookingName){
                    this.validationMessage = "調理名を入力してください。";
                    return false;
                }
            }

            for(var g = 0 ; g < cookingNameListArray.length ; g++) {
                if(cookingNameListArray[g].alertSetting.time === null || cookingNameListArray[g].alertSetting.time === undefined){
                  this.validationMessage = cookingNameListArray[g].cookingName+"のアラート通知時間を入力してください。";
                  return false;
                }
            }

            //桁数チェック
            for(var p = 0 ; p < cookingNameListArray.length ; p++) {
                if(String(cookingNameListArray[p].cookingName).length > 20){
                    this.validationMessage = "調理名は20桁以内で入力してください。";
                    return false;
                }
            }

            for(var r = 0 ; r < cookingNameListArray.length ; r++) {
              if(String(cookingNameListArray[r].groupName).length > 20){
                this.validationMessage = "グループ名は20桁以内で入力してください。";
                return false;
              }
            }

            //重複チェック
            for(var h = 0 ; h < cookingNameListArray.length ; h++) {

                if ((h + 1) !== cookingNameListArray.length) {
                    var inpuotApiDataObj = cookingNameListArray[h];
                    for (var i = h+1; i < cookingNameListArray.length; i++) {
                        if (inpuotApiDataObj.cookingName == cookingNameListArray[i].cookingName) {
                            this.validationMessage = '調理名は既に登録されています'
                            return false;
                        }
                    }
                }
            }

            // リリース日の必須チェック
            if(this.date == null){
                this.validationMessage="リリース日を入力してください。"
                this.addFormFlg = false;
                return;
            }

            // リリース日が現在、または過去の指定はNG
            if(this.selectDateFormat(this.date) <= this.chartDateBusinessDay(new Date())){
                this.validationMessage="リリース日指定は未来日を入力してください。"
                return false;
            }

            // 指定されたリリース日が半年以上の場合はNG
            var toDate = new Date()
            toDate.setDate(toDate.getDate()+180);
            if(this.selectDateFormat(this.date) > this.selectDateFormat(toDate)){
                this.validationMessage="リリース日は半年以内で入力してください。"
                return false;
            }

            // 温度の形式チェック
            for(var k = 0 ; k < cookingNameListArray.length ; k++) {
                //空白チェック
                if (cookingNameListArray[k].heatedUpperTemperature === '' || cookingNameListArray[k].heatedLowerTemperature === '') {
                  this.validationMessage = '加熱後温度の上・下限は 数字、記号「.」「-」 のみ使用できます。';
                  return false;
                }
                if (this.cookingCheckButtonNo == 5 && cookingNameListArray[k].reHeatedUpperTemperature === '' || cookingNameListArray[k].reHeatedLowerTemperature === '') {
                  this.validationMessage = '再加熱後温度の上・下限は 数字、記号「.」「-」 のみ使用できます。';
                  return false;
                }
                //形式チェック
                if (!this.checkStrong2(cookingNameListArray[k].heatedUpperTemperature) || !this.checkStrong2(cookingNameListArray[k].heatedLowerTemperature)) {
                  this.validationMessage = '加熱後温度の上・下限は 数字、記号「.」「-」 のみ使用できます。';
                  return false;
                }
                if (this.cookingCheckButtonNo == 5 && !this.checkStrong2(cookingNameListArray[k].reHeatedUpperTemperature) || !this.checkStrong2(cookingNameListArray[k].reHeatedLowerTemperature)) {
                  this.validationMessage = '再加熱後温度の上・下限は 数字、記号「.」「-」 のみ使用できます。';
                  return false;
                }
            }

            return true;
        },
        addColum(){

            // 種別の選択確認
            this.validationMessage = "";
            if(this.cookingCheckButtonId === null){
                this.validationMessage = 'ボタン名を選択してください。'
                this.scrollTop();
                return null;
            }

            if(this.cookingCheckButtonData.cookingNameList.length >= 200 ){
                this.validationMessage = '調理名は200件まで登録可能です'
                this.scrollTop();
                return null;
            }

            var newInputList = new Array();
            for(var i =0 ; i < this.headerItemNameList.length ; i++) {
                var newItemInputObj = new Object();
                newItemInputObj['cookingCheckHeaderId'] = this.headerItemNameList[i].cookingCheckHeaderId;
                newItemInputObj['inputFlg'] = 1;
                newInputList.push(newItemInputObj);
            }

            var cookingNameListOjb = new Object();
            cookingNameListOjb['inputList'] = newInputList;
            cookingNameListOjb['cookingId'] = '';
            cookingNameListOjb['cookingName'] = '';
            cookingNameListOjb['cookingNameNo'] = this.cookingCheckButtonData.cookingNameList.length + 1;
            cookingNameListOjb['groupName'] = null;
            cookingNameListOjb['heatedUpperTemperature'] = null;
            cookingNameListOjb['heatedLowerTemperature'] = null;
            cookingNameListOjb['reHeatedUpperTemperature'] = null;
            cookingNameListOjb['reHeatedLowerTemperature'] = null;
            cookingNameListOjb['alertSetting'] = this.alertSetting;

            this.cookingCheckButtonData.cookingNameList.push(cookingNameListOjb);

        },
        delecSelect(indexCount){

            var tyoriDataList = [];
            tyoriDataList = this.cookingCheckButtonData['cookingNameList'];
            tyoriDataList.splice(indexCount,1);

            //indexを振りなおす
            for(var k = 0 ; k < tyoriDataList.length ; k++) {
                var deleteApiDataObj = tyoriDataList[k];
                deleteApiDataObj['cookingNameNo'] = k+1;
                tyoriDataList.splice(k,1,deleteApiDataObj);
            }
            this.cookingCheckButtonData.cookingNameList = tyoriDataList;
        },
        async sendSenser(){

            this.showContent2 = false;
            this.isLoading = true;

            //エラー内容初期化
            this.clearError();

            let cookingNameListArray = this.cookingCheckButtonData.cookingNameList;

            // バリデーションチェック
            if(!this.validationCheck(cookingNameListArray)){
                this.isLoading = false;
                this.scrollTop();
                return null;
            }

            //正常時、API呼び出し
            let ListArrayRequestArray = this.getRequestArray(cookingNameListArray);

            // API処理判定
            var apiResponseFlg = true;

            var brandId = this.$store.getters['brand/id'];
            var cookingCheckButtonId = this.selectButtonId;
            var url = this.$apiEndpoint + 'manage/brand/' + brandId + '/cooking_check/' + cookingCheckButtonId + '/cooing_name';

            // 連携する日付を設定(日付は常にリリース日を入力の内容を送信する)
            var postApplyStartDate = "";
            postApplyStartDate = this.selectDateFormat(this.date);

            await this.$axios
                .post(url,{cookingNameList:ListArrayRequestArray,apply_start_date: postApplyStartDate})
                .then()
                .catch((err)=> {
                    let error = {
                        button: {
                            path: {name: 'top', params:{brandPath: this.brandPath}}
                        }}
                    apiResponseFlg = false;
                    if (err.customError) {
                        error = Object.assign(error, err.customError);

                        if(error.code == 400){
                            this.validationMessage =  error.message;
                            this.scrollTop();
                        }
                    }
                    if(error.code !== 400){
                        this.$store.dispatch('error/setError', error).then(this.$router.push({name: 'error'}))
                    }
                }).finally(()=> this.isLoading = false);

            // API処理判定
            if(apiResponseFlg){
                this.showContent3 = true;
            }
        },
        getRequestArray(cookingNameListArray) {
            var ListArrayRequestArray = new Array();
            // 送信用データ作成
            for(var listArrayCount =0 ; listArrayCount < cookingNameListArray.length ; listArrayCount++){
                var requestObj = new Object();
                var ListArrayDataArray = new Array();
                for(var listArrayDataCount = 0 ; listArrayDataCount < cookingNameListArray[listArrayCount].inputList.length ; listArrayDataCount++){
                    var ListArrayDataObj = new Object();
                    ListArrayDataObj['cooking_check_header_id'] = cookingNameListArray[listArrayCount].inputList[listArrayDataCount].cookingCheckHeaderId;
                    ListArrayDataObj['input_flg'] = cookingNameListArray[listArrayCount].inputList[listArrayDataCount].inputFlg;
                    ListArrayDataArray.push(ListArrayDataObj);
                }
                requestObj['no'] = cookingNameListArray[listArrayCount].cookingNameNo;
                requestObj['cooking_name'] = cookingNameListArray[listArrayCount].cookingName;
                requestObj['inputList'] = ListArrayDataArray;
                requestObj['groupName'] = cookingNameListArray[listArrayCount].groupName;
                requestObj['heatedUpperTemperature'] = cookingNameListArray[listArrayCount].heatedUpperTemperature;
                requestObj['heatedLowerTemperature'] = cookingNameListArray[listArrayCount].heatedLowerTemperature;
                requestObj['reHeatedUpperTemperature'] = cookingNameListArray[listArrayCount].reHeatedUpperTemperature;
                requestObj['reHeatedLowerTemperature'] = cookingNameListArray[listArrayCount].reHeatedLowerTemperature;
                requestObj['alertSetting'] = cookingNameListArray[listArrayCount].alertSetting;
                ListArrayRequestArray.push(requestObj)
            }
            return ListArrayRequestArray;
        },
        async selectCookingId(event){

            this.isLoading = true;
            var brandId = this.$store.getters['brand/id'];
            var apiResponseFlg = true;
            if(event !== null){
                this.selectButtonId = event.target.value;
                this.cookingCheckButtonId = event.target.value;
                // ボタン選択が変更された場合、リリース日、入力を初期化する。
                this.date = null;
                this.applyStartDate = null;
                // datepikerの日付を成形(翌日日付け)
                this.vDatePickerMinDay = this.checkDateBusinessDay();
            }

            // 種別の選択確認
            this.validationMessage = "";
            if(this.cookingCheckButtonId === null){
                this.validationMessage = 'ボタン名を選択してください。'
                this.isLoading = false;
                this.scrollTop();
                return null;
            }

            var applyStartDate = "";
            // 取得する日付を指定
            if(this.applyStartDate !== null){
                applyStartDate = this.applyStartDate;
            }

            this.cookingCheckButtonNo = this.cookingCheckButton.find(item => item.cookingCheckButtonId == parseInt(this.cookingCheckButtonId)).cookingCheckButtonNo;

            // 調理名一覧取得API
            var url = this.$apiEndpoint + 'manage/brand/' + brandId + '/cooking_check/' + this.cookingCheckButtonId + '/cooing_name';

            await this.$axios
                .get(url,{ params: {apply_start_date:applyStartDate}})
                .then(response => (this.cookingCheckButtonData = response.data.cookingCheckButton,
                    this.releaseHistories = response.data.cookingCheckButton.releaseHistories,
                    this.applyStartDate = response.data.cookingCheckButton.applyStartDate,
                    this.groupNameList = [...new Set(this.cookingCheckButtonData.cookingNameList.map(item => item.groupName).filter(group => group))]))
                .catch((err) => {
                    let error = {
                        button: {
                            path: {name: 'top', params:{brandPath: this.brandPath}}
                       }}
                    if (err.customError) {
                        error = Object.assign(error, err.customError)
                    }
                    this.$store.dispatch('error/setError', error).then(this.$router.push({name: 'error'}))
                }).finally(()=> this.isLoading = false);

            // API処理判定
            if(!apiResponseFlg){
                return null;
            }

            var headerAllCount = 0;
            var groupCount = 0
            var headerItemListkeys = Object.keys(this.cookingCheckButtonData.headerItemList);
            var headerItemInputList = new Array();
            this.headerItemNameList = [];
            for(var i =0 ; i < headerItemListkeys.length ; i++){

                var headerItemInputObj = new Object();

                // キー情報
                var headerKey = headerItemListkeys[i];
                var headerItemListData = this.cookingCheckButtonData.headerItemList[headerKey];
                // キー別のリストカウント
                var headerItemListDataCount = headerItemListData.length;

                // ヘッダー名を格納
                for(var k =0 ; k < headerItemListData.length ; k++){
                    this.headerItemNameList.push(headerItemListData[k])
                }

                // Dataへ格納
                headerItemInputObj['colGroupName'] = headerKey;
                if(headerKey === 'inputType_4') {
                  headerItemInputObj['colGroupName'] = '';
                }
                headerItemInputObj['colGroupCount'] = headerItemListDataCount;
                headerItemInputList.push(headerItemInputObj);
                headerAllCount = headerAllCount + headerItemListDataCount;
                groupCount = groupCount + 1;
            }
            this.colGroupSetting = headerItemInputList;
            this.colGroupAllCount = headerAllCount;
            this.rowspan = groupCount;
            for(var j =0 ; j < this.cookingCheckButtonData.cookingNameList.length ; j++){
                this.cookingCheckButtonData.cookingNameList[j]['alertSetting'] = {
                    format:'毎日 00:00',
                    isSet: 0,
                    time: '00:00',
                    repeat_type: 0,
                    weekday: 0,
                    monthday: 1,
                    monthday_second:null
                };
                if(this.cookingCheckButtonData.cookingNameList[j].alertId != null){
                    this.cookingCheckButtonData.cookingNameList[j]['alertSetting'] = {
                        format:this.settingFormat(
                            this.cookingCheckButtonData.cookingNameList[j].repeatType,
                            this.cookingCheckButtonData.cookingNameList[j].weekday,
                            this.cookingCheckButtonData.cookingNameList[j].monthday,
                            this.cookingCheckButtonData.cookingNameList[j].monthdaySecond,
                            this.cookingCheckButtonData.cookingNameList[j].checkTime) ,
                        isSet: this.cookingCheckButtonData.cookingNameList[j].status,
                        time: this.cookingCheckButtonData.cookingNameList[j].checkTime,
                        repeat_type: this.cookingCheckButtonData.cookingNameList[j].repeatType,
                        weekday: this.cookingCheckButtonData.cookingNameList[j].weekday,
                        monthday: this.cookingCheckButtonData.cookingNameList[j].monthday,
                        monthday_second: this.cookingCheckButtonData.cookingNameList[j].monthdaySecond,
                    };
                }
            }



        },
        clearError:function(){
            //メッセージ初期化
            this.validationMessage = "";
        },
        closeModel() {
            this.showContent = false;
        },
        dateFormat(){
            let nowDate = new Date();
            let year = nowDate.getFullYear();
            let month = ("0" + (nowDate.getMonth()+1)).slice(-2);
            let day = ("0" + nowDate.getDate()).slice(-2);
            let hours = ("0" + nowDate.getHours()).slice(-2);
            let minutes = ("0" + nowDate.getMinutes()).slice(-2);
            let seconds = ("0" + nowDate.getSeconds()).slice(-2);

            let format_str = 'YYYYMMDDhhmmss'
            format_str = format_str.replace(/YYYY/g,year);
            format_str = format_str.replace(/MM/g,month);
            format_str = format_str.replace(/DD/g,day);
            format_str = format_str.replace(/hh/g,hours);
            format_str = format_str.replace(/mm/g,minutes);
            format_str = format_str.replace(/ss/g,seconds);
            return format_str;
        },
        //〇ボタン押下時のlist書き換え用メソッド
        clickChech:function (index,indexCount,cookingCheckHeaderId) {

          //ボタン押下時のクリック制御
          var buttonCheckList = this.cookingCheckButtonData.cookingNameList[index].inputList[indexCount];
          if(buttonCheckList['inputFlg'] == 0){
            buttonCheckList['inputFlg'] = 1;
            buttonCheckList['cookingCheckHeaderId'] = cookingCheckHeaderId;
          } else if(buttonCheckList['inputFlg'] == 1) {
            buttonCheckList['inputFlg'] = 2;
            buttonCheckList['cookingCheckHeaderId'] = cookingCheckHeaderId;
          }else{
            buttonCheckList['inputFlg'] = 0;
            buttonCheckList['cookingCheckHeaderId'] = cookingCheckHeaderId;
          }
          this.cookingCheckButtonData.cookingNameList[index].inputList.splice(indexCount,1,buttonCheckList);
        },
        upArrangement:function (arrangementRuleNo) {

          var upparData = this.cookingCheckButtonData.cookingNameList[arrangementRuleNo];
          upparData['cookingNameNo'] = this.cookingCheckButtonData.cookingNameList[arrangementRuleNo].cookingNameNo-1;

          var lowerData = this.cookingCheckButtonData.cookingNameList[arrangementRuleNo-1];
          lowerData['cookingNameNo'] = this.cookingCheckButtonData.cookingNameList[arrangementRuleNo].cookingNameNo+1;

          //配列に反映
          this.cookingCheckButtonData.cookingNameList.splice(arrangementRuleNo-1,1,upparData);
          this.cookingCheckButtonData.cookingNameList.splice(arrangementRuleNo,1,lowerData);

        },
        lowArrangement:function (arrangementRuleNo) {

          var upparData = this.cookingCheckButtonData.cookingNameList[arrangementRuleNo + 1];
          upparData['cookingNameNo'] = this.cookingCheckButtonData.cookingNameList[arrangementRuleNo + 1].cookingNameNo-1;

          var lowerData = this.cookingCheckButtonData.cookingNameList[arrangementRuleNo];
          lowerData['cookingNameNo'] = this.cookingCheckButtonData.cookingNameList[arrangementRuleNo].cookingNameNo+1;


          //配列に反映
          this.cookingCheckButtonData.cookingNameList.splice(arrangementRuleNo,1,upparData);
          this.cookingCheckButtonData.cookingNameList.splice(arrangementRuleNo+1,1,lowerData);
        },
        scrollTop() {
            window.scrollTo(0,0);
        },
        releaseDayDelete(){
            this.showContentKbn = 3;
            this.showContent2 = true;
        },
        releaseDayUpAdd(){

            //エラー内容初期化
            this.clearError();

            // バリデーションチェックを実施
            let cookingNameListArray = this.cookingCheckButtonData.cookingNameList;

            // バリデーションチェック
            if(!this.validationCheck(cookingNameListArray)){
                this.scrollTop();
                return null;
            }

            var Kbn = false;
            this.updateKbn = 0 ;

            // 「リリース日の入力」があり、履歴内に存在する場合は、更新として扱う。
            var dateFor = this.selectDateFormat(this.date)
            for(var i = 0 ; i < this.releaseHistories.length ; i++){
              if(dateFor === this.releaseHistories[i]){
                Kbn = true;
                this.updateKbn = 1;
                break;
              }
            }

            // フラグ判定
            if(Kbn){
              this.showContentKbn = 2;
            }
            else{
              this.showContentKbn = 1;
            }

            this.showContent2 = true;

        },
        closeModelDelete(){
            this.showContent2 = false;
        },
        async delModel(){

            this.isLoading = true;
            var apiResponseFlg = true;
            this.showContent2 = false;
            var brandId = this.$store.getters['brand/id'];

            // リリース日のチェック
            if(this.applyStartDate !== null){
                if(this.applyStartDate <= this.selectDateFormat(new Date())){
                    this.validationMessage="過去のリリース日履歴は削除出来ません。";
                    this.isLoading = false;
                    return null;
                }
            }

            var URL = this.$apiEndpoint + 'manage/brand/' + brandId + '/cooking_check/' + this.cookingCheckButtonId + "/cooing_name/delete"

            // 調理名削除PI
            await this.$axios
                .post(URL, {apply_start_date: this.applyStartDate})
                .catch((err) => {
                    let error = {
                        button: {
                            path: {name: 'top', params:{brandPath: this.brandPath}}
                        }}
                    apiResponseFlg = false;
                    if (err.customError) {
                        error = Object.assign(error, err.customError);

                        if(error.code == 400){
                            this.validationMessage =  error.message;
                            this.scrollTop();
                        }
                    }
                    if(error.code !== 400){
                        this.$store.dispatch('error/setError', error).then(this.$router.push({name: 'error'}))
                    }
                }).finally(()=> this.isLoading = false);

            if(apiResponseFlg){
                this.showContent3 = true;
            }
        },
        closeModelComp(){
            this.showContent3 = false;
            // 削除の場合、画面を初期化する。
            if(this.showContentKbn == 3){
                // 削除の場合、リリース日の指定は初期化する
                this.applyStartDate = null;
            }
            // 初期化処理
            this.selectCookingId(null);
            // パラメータ初期化
            this.showContentKbn = null;
            this.date = null;
            this.scrollTop();
        },
        selectDateFormat(date){
            let year = date.getFullYear();
            let month = ("0" + (date.getMonth()+1)).slice(-2);
            let day = ("0" + date.getDate()).slice(-2);

            let format_str = 'YYYY/MM/DD';
            format_str = format_str.replace(/YYYY/g,year);
            format_str = format_str.replace(/MM/g,month);
            format_str = format_str.replace(/DD/g,day);

            return format_str;
        },
        init(){
            // 画面の初期化
            this.selectCookingId(null);
        },
        jsonToFormData(data) {
            const formData = new FormData();

            this.buildFormData(formData, data);

            return formData;
        },
        buildFormData(formData, data, parentKey) {
            if (data && typeof data === 'object' && !(data instanceof Date) && !(data instanceof File)) {
                Object.keys(data).forEach(key => {
                    this.buildFormData(formData, data[key], parentKey ? `${parentKey}[${key}]` : key);
                });
            } else {
                const value = data == null ? '' : data;

                formData.append(parentKey, value);
            }
        },
        checkDateBusinessDay(){
            let minAllowedDay = new Date();
            let hours = ("0" + minAllowedDay.getHours()).slice(-2);

            // AM00-AM03時の判定
            if(hours >= '03' && hours <= '23'){
                minAllowedDay.setDate(minAllowedDay.getDate() +1);
            }
            return new Date(minAllowedDay.getFullYear(),minAllowedDay.getMonth(),minAllowedDay.getDate());
        },
        chartDateBusinessDay(date){

            let year = date.getFullYear();
            let month = ("0" + (date.getMonth()+1)).slice(-2);
            let day = ("0" + date.getDate()).slice(-2);
            let hours = ("0" + date.getHours()).slice(-2);

            // AM00-AM03時の判定
            if(hours >= '00' && hours < '03'){

                // 年始の考慮
                if(month == '01' && day == '01'){
                    var yearEndDate = new Date(date.getFullYear()-1,12,0);
                    year = date.getFullYear()-1;
                    month = 12;
                    day = ("0" + yearEndDate.getDate()).slice(-2);

                }
                // 月末の考慮
                else if(day == '01'){
                    var monthEndDate = new Date(date.getFullYear(),date.getMonth(),0);
                    month = ("0" + (date.getMonth())).slice(-2);
                    day = ("0" + monthEndDate.getDate()).slice(-2);
                }
                // 前日日付の営業日
                else{
                    var dayBeforeDate = new Date(date.getFullYear(),date.getMonth()+1,date.getDate()-1);
                    day =  ("0" + dayBeforeDate.getDate()).slice(-2);
                }
            }

            let format_str = 'YYYY/MM/DD';
            format_str = format_str.replace(/YYYY/g,year);
            format_str = format_str.replace(/MM/g,month);
            format_str = format_str.replace(/DD/g,day);

            return format_str;
        },
        changeGroupName() {
          this.groupNameList = [...new Set(this.cookingCheckButtonData.cookingNameList.map(item => item.groupName).filter(group => group))];
        },
        //数字、記号「.」「-」 のチェック
        checkStrong2:function(inputdata){
            if(!inputdata){
              return true;
            }

            const re = new RegExp(/^[-]?([1-9]\d*|0)(\.\d+)?$/);
            return re.test(inputdata);
        },
        clickAlertSetting:function (index) {
            this.selectIndex = index;
            this.alertSetting = this.cookingCheckButtonData.cookingNameList[this.selectIndex].alertSetting
            this.showContent4 = true;
        },
        closeAlertSettingModel:function () {
            this.showContent4 = false;
        },
        clickLumpAlertSetting:function () {
          this.selectIndex = null;
          this.alertSetting = this.lumpAlertSetting;
          this.showContent4 = true;
        },
        changeFormat() {
            var week = this.weekdays.find(item => item.value == this.alertSetting.weekday).text;
            var day = this.monthdays.find(item => item.value == this.alertSetting.monthday).text;
            switch (this.alertSetting.repeat_type) {
              case 0:
                this.alertSetting.format = '毎日 '+this.alertSetting.time;break;
              case 1:
                this.alertSetting.format = '毎週 '+week+"曜日 "+this.alertSetting.time;break;
              case 2:
                if(this.alertSetting.monthday_second == null){
                  this.alertSetting.format = '毎月 '+day+" "+this.alertSetting.time;break;
                } else {
                  var day2 = this.monthdays.find(item => item.value == this.alertSetting.monthday_second).text;
                  this.alertSetting.format = '毎月 '+day+" "+day2+" "+this.alertSetting.time;break;
                }
            }
        },
        setAlertSetting() {
          if(this.isLump){
            for(var j =0 ; j < this.cookingCheckButtonData.cookingNameList.length ; j++){
              this.cookingCheckButtonData.cookingNameList[j]['alertSetting'] = {
                format: this.lumpAlertSetting.format,
                isSet: this.lumpAlertSetting.isSet,
                time: this.lumpAlertSetting.time,
                repeat_type: this.lumpAlertSetting.repeat_type,
                weekday: this.lumpAlertSetting.weekday,
                monthday: this.lumpAlertSetting.monthday,
                monthday_second: this.lumpAlertSetting.monthday_second,
              };
            }
          } else {
            this.cookingCheckButtonData.cookingNameList[this.selectIndex]['alertSetting'] = {
              format: this.alertSetting.format,
              isSet: this.alertSetting.isSet,
              time: this.alertSetting.time,
              repeat_type: this.alertSetting.repeat_type,
              weekday: this.alertSetting.weekday,
              monthday: this.alertSetting.monthday,
              monthday_second: this.alertSetting.monthday_second,
            };
          }
          this.showContent4 = false;

        },
        clearMonthday() {
          if(this.isLump){
            this.lumpAlertSetting.monthday_second = null;
          } else {
            this.alertSetting.monthday_second = null;
          }
          this.changeFormat();
        },
      chengIsLump() {
        if(this.isLump){
          this.lumpAlertSetting.isSet = 1
          for(var j =0 ; j < this.cookingCheckButtonData.cookingNameList.length ; j++){
            this.cookingCheckButtonData.cookingNameList[j]['alertSetting']['isSet'] = 1;
          }
        }
      },
      settingFormat(repeat_type, weekday,monthday,monthday_second,time) {
        var format = "毎日 00:00";
        var week = this.weekdays.find(item => item.value == weekday).text;
        var day = this.monthdays.find(item => item.value == monthday).text;
        switch (repeat_type) {
          case 0:
            format = '毎日 '+time;break;
          case 1:
            format = '毎週 '+week+"曜日 "+time;break;
          case 2:
            if(monthday_second == null){
              format = '毎月 '+day+" "+time;break;
            } else {
              var day2 = this.monthdays.find(item => item.value == monthday_second).text;
              format = '毎月 '+day+" "+day2+" "+time;break;
            }
        }
        return format;
      },
    }
}
</script>